import { BmHttp } from "../utils/Global";

export const ListarRolesAdmin = async () => {
  const { data } = await BmHttp().get("roles");
  return data;
};

export const ObtenerRolAdmin = async (idrol) => {
  const { data } = await BmHttp().get(`roles/${idrol}`);
  return data;
};

export const CrearRolAdmin = async (payload) => {
  const { data } = await BmHttp().post("roles", payload);
  return data;
};

export const ActualizarRolAdmin = async (idrol, payload) => {
  const { data } = await BmHttp().put(`roles/${idrol}`, payload);
  return data;
};

export const EliminarRolAdmin = async (idrol) => {
  const { data } = await BmHttp().delete(`roles/${idrol}`);
  return data;
};

export const ListarCatalogoPermisos = async () => {
  const { data } = await BmHttp().get("roles/permissions/catalog");
  return data;
};

export const ReemplazarPermisosRol = async (idrol, permissionIds) => {
  const { data } = await BmHttp().put(`roles/${idrol}/permissions`, {
    permission_ids: permissionIds,
  });
  return data;
};

export const ListarUsuariosRol = async (idrol) => {
  const { data } = await BmHttp().get(`roles/${idrol}/users`);
  return data;
};

export const ObtenerPermisosEfectivosUsuario = async (iduser) => {
  const { data } = await BmHttp().get(`users/${iduser}/effective-permissions`);
  return data;
};

export const OtorgarPermisoExtra = async (iduser, idpermiso) => {
  const { data } = await BmHttp().post(`users/${iduser}/permissions-extra`, {
    idpermiso,
  });
  return data;
};

export const RevocarPermisoExtra = async (iduser, idpermiso) => {
  const { data } = await BmHttp().delete(
    `users/${iduser}/permissions-extra/${idpermiso}`
  );
  return data;
};
